import React from 'react';
import { Breadcrumb } from 'antd';
import { useLayoutStyles } from '../styles';
import { Link } from 'react-router-dom';
import { capitalizeFirstLetter } from '../utils';

type CrumbInfo = {
  index?: number;
  key?: string;
};

type BreadCrumbsProps = {
  omitCrumbList?: CrumbInfo[];
};

export const BreadCrumbs = ({ omitCrumbList = [] }: BreadCrumbsProps) => {
  const crumbs: Record<string, string>[] = window.location.pathname
    .toString()
    .split('/')
    .slice(1)
    .reduce<Record<string, string>[]>(
      (prev, curr) => [
        ...prev,
        {
          title: capitalizeFirstLetter(curr),
          key: curr,
          url: (prev.length > 0 ? prev[prev.length - 1].url : '').concat('/', curr),
        },
      ],
      [],
    );
  const classes = useLayoutStyles();

  const notOmitted = ({ index, key }: CrumbInfo) => {
    for (const crumb of omitCrumbList) {
      if ((crumb.index === undefined || crumb.index === index) && (crumb.key === undefined || crumb.key === key)) {
        return false;
      }
    }
    return true;
  };
  return (
    <Breadcrumb className={classes.breadCrumbs} style={{ height: '100%' }}>
      <div style={{ marginRight: '10px' }}>{<Link to={crumbs[0].url}>{crumbs[0].title}</Link>} |</div>
      {crumbs
        .slice(1)
        .filter((crumb, index) => {
          return notOmitted({ index: index, key: crumb.key });
        })
        .map((crumb) => (
          <Breadcrumb.Item>
            <Link to={crumb.url}>{crumb.title}</Link>
          </Breadcrumb.Item>
        ))}
    </Breadcrumb>
  );
};
